import React, { useRef } from 'react';
import styled from 'styled-components';
import { CaretLeft, CaretRight } from 'phosphor-react';

interface CustomizationCarouselProps {
  children: React.ReactNode;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
  itemsPerPage: number;
}

export const CustomizationCarousel: React.FC<CustomizationCarouselProps> = ({ children, itemsPerPage }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.offsetWidth * (direction === 'left' ? -0.8 : 0.8);
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <CarouselWrapper>
      <ArrowButton onClick={() => scroll('left')} position="left">
        <CaretLeft size={24} />
      </ArrowButton>
      
      <CarouselContainer ref={scrollRef} itemsPerPage={3}>
        {children}
      </CarouselContainer>
      
      <ArrowButton onClick={() => scroll('right')} position="right">
        <CaretRight size={24} />
      </ArrowButton>
    </CarouselWrapper>
  );
};

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;

  @media (max-width: 900px) {
    padding: 0 16px;
    max-width: 100vw;
  }
`;

const CarouselContainer = styled.div<{ itemsPerPage: number }>`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 8px 0;
  width: 100%;
  
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 900px) {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    gap: 8px;
    
    & > * {
      scroll-snap-align: start;
      flex: 0 0 calc((100% - 24px) / 4);
      min-width: calc((100% - 24px) / 4);
      width: calc((100% - 24px) / 4);
    }
  }

  @media (max-width: 600px) {
    & > * {
      flex: 0 0 calc((100% - 16px) / 3);
      min-width: calc((100% - 16px) / 3);
      width: calc((100% - 16px) / 3);
    }
  }
`;

const ArrowButton = styled.button<{ position: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${props => props.position}: ${props => props.position === 'left' ? '4px' : '4px'};
  transform: translateY(-50%);
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
  color: #666;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #f8f9fa;
    color: #ff6320;
  }

  @media (max-width: 900px) {
    width: 24px;
    height: 24px;
  }
`; 